import { render } from "./FeaturedProductsComponent.vue?vue&type=template&id=627e9fe8"
import script from "./FeaturedProductsComponent.vue?vue&type=script&lang=js"
export * from "./FeaturedProductsComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"platform/themes/iteam/assets/js/components/FeaturedProductsComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "627e9fe8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('627e9fe8', __exports__)) {
    api.reload('627e9fe8', __exports__)
  }
  
  module.hot.accept("./FeaturedProductsComponent.vue?vue&type=template&id=627e9fe8", () => {
    api.rerender('627e9fe8', render)
  })

}


export default __exports__